// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Utils
import { getDecimalNum } from "src/utils/number/numberHelper";

// Types
import { AnisocoriaResultsType } from "src/services/exams/types";

type RAPDPupilDiametersType = {
  anisocoriaResults: AnisocoriaResultsType;
};

const RAPDPupilDiameters = ({ anisocoriaResults }: RAPDPupilDiametersType) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        borderRadius: "4px",
        border: "1px solid #000",
        width: "100%",
      }}
    >
      <Typography
        sx={{
          background: "#000",
          color: "#FFF",
          padding: "8px",
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        {t("Pupil Diameters")}
      </Typography>

      <Grid
        item
        xs={12}
        display="flex"
        flexWrap="wrap"
        padding="8px"
        rowGap="8px"
      >
        <Grid
          item
          xs={12}
          sm={6}
          display="flex"
          flexDirection="column"
          gap="8px"
        >
          <Typography fontSize="14px">{t("Left Eye")} (OS)</Typography>
          <Box
            display="flex"
            flexDirection="column"
            gap="8px"
            justifyContent="space-around"
          >
            <ul
              style={{
                listStyleType: "disc",
                paddingInlineStart: "16px",
                margin: 0,
              }}
            >
              <li>
                <Typography fontSize="14px">
                  <span style={{ fontWeight: 600 }}>{t("Dim Light")}:</span>{" "}
                  {getDecimalNum(anisocoriaResults?.dimLightLeft, 1)} mm
                </Typography>
              </li>
              <li>
                <Typography fontSize="14px" my="8px">
                  <span style={{ fontWeight: 600 }}>{t("Bright Light")}:</span>{" "}
                  {getDecimalNum(anisocoriaResults?.brightLightLeft, 1)} mm
                </Typography>
              </li>
            </ul>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          display="flex"
          flexDirection="column"
          gap="8px"
        >
          <Typography fontSize="14px">{t("Right Eye")} (OD)</Typography>
          <Box
            display="flex"
            flexDirection="column"
            gap="8px"
            justifyContent="space-around"
          >
            <ul
              style={{
                listStyleType: "disc",
                paddingInlineStart: "16px",
                margin: 0,
              }}
            >
              <li>
                <Typography fontSize="14px">
                  <span style={{ fontWeight: 600 }}>{t("Dim Light")}:</span>{" "}
                  {getDecimalNum(anisocoriaResults?.dimLightRight, 1)} mm
                </Typography>
              </li>
              <li>
                <Typography fontSize="14px" my="8px">
                  <span style={{ fontWeight: 600 }}>{t("Bright Light")}:</span>{" "}
                  {getDecimalNum(anisocoriaResults?.brightLightRight, 1)} mm
                </Typography>
              </li>
            </ul>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RAPDPupilDiameters;
